import { Model } from "./Model";
import { Place } from "./Place";
import { Phone } from "./Phone";
import { Project } from "./Project";
import { Contract } from "./Contract";
import { ContactTypes } from "../constants/contact-enums";

export class Contact extends Model {
  static props = {
    id: { type: Number },
    name: { type: String },
    last_name: { type: String },
    type: { type: String, default: "" },
    subtype: { type: String },
    company_name: { type: String },
    title: { type: String },
    email: { type: String },
    website_url: { type: String },
    keywords: { type: String },
    primary_place: { type: Place, default: new Place() },
    additional_places: { type: Array, default: [] },
    places: { type: Array, default: [] },
    projects: { type: Array, default: [] },
    contracts: { type: Array, default: [] },
    primary_phone: {
      type: Phone,
      default: new Phone()
    },
    additional_phones: { type: Array, default: [] },
    note: { type: Object }
  };

  /**
   * @param parameters  Object
   */
  constructor(parameters) {
    super(Contact.props, parameters);
  }

  mapParametersToModel(parameters, props) {
    super.mapParametersToModel(parameters, props);
    if (parameters) {
      // Make sure 'additional_places' is array of Places
      if (parameters.additional_places) {
        this.additional_places = parameters.additional_places.map(place => {
          if (place.constructor === Object) {
            return new Place(place);
          }
          return place;
        });
      }
      // Make sure 'places' is array of Places
      if (parameters.places) {
        this.places = parameters.places.map(place => {
          if (place.constructor === Object) {
            return new Place(place);
          }
          return place;
        });
      }
      // Make sure 'projects' is array of Projects
      if (parameters.projects) {
        this.projects = parameters.projects.map(project => {
          if (project.constructor === Object) {
            return new Project(project);
          }
          return project;
        });
      }
      // Make sure 'contracts' is array of Projects
      if (parameters.contracts) {
        this.contracts = parameters.contracts.map(contract => {
          if (contract.constructor === Object) {
            contract.primary_contact = parameters.name;
            contract.primary_contact_id = parameters.id;

            return new Contract(contract);
          }
          return contract;
        });
      }
      // Make sure 'additional_phones' is array of Phones
      if (parameters.additional_phones) {
        this.additional_phones = parameters.additional_phones.map(phone => {
          if (phone.constructor === Object) {
            return new Phone(phone);
          }
          return phone;
        });
      }
    }
  }

  get primaryPhoneNumber() {
    return this.primary_phone && this.primary_phone.number
      ? this.primary_phone.number
      : "";
  }

  get primaryPhoneType() {
    return this.primary_phone && this.primary_phone.type
      ? this.primary_phone.type
      : "";
  }

  get primaryPhoneDisplayString() {
    return this.primaryPhoneType
      ? `${this.primaryPhoneNumber} (${this.primaryPhoneType})`
      : this.primaryPhoneNumber;
  }

  get companyAndContactNamesString() {
    if (this.company_name) {
      return this.name
        ? `${this.company_name} - ${this.name}`
        : this.company_name;
    }
    return this.name;
  }

  get displayName() {
    if (
      this.type === ContactTypes.PARTNER ||
      this.type === ContactTypes.VENDOR
    ) {
      return this.companyAndContactNamesString;
    }
    return this.name;
  }
}
